import React, { useEffect, useState } from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap'
import _ from 'lodash'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

const Create = props => {
  return (
    <Modal
      isOpen={ props.showCreateCourse }
      size={ 'xl' }>
      <ModalHeader toggle={() => props.onChangeCoursesHOC( 'showCreateCourse', false )}>Create course</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>
              Name
              <span className="text-danger"> *</span>
            </Label>
            <Input
              type="text"
              value={ props.newCourse.name }
              onChange={ e => {
                let tmp = _.cloneDeep( props.newCourse )
                tmp[ 'name' ] = e.target.value
                tmp[ 'session_id' ] = props.data.SessionReducer.current_selected_session_id
                return props.onChangeCoursesHOC( 'newCourse', tmp )
              }} />
          </FormGroup>
        </Form>
        { props.onLoadCourses && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => props.createCourse( props.newCourse )}>Submit</Button>
      </ModalFooter>
    </Modal>
  )
}

export default Create